<!-- TodaySummary.vue -->
<template>
	<div>
		<div class="row">
			<div class="col-md-12">
				<div>
					<el-form label-position="top" label-width="100px">
						<div class="row">
							<div class="col-md-5">	
								<el-form-item label="Station">
									<el-select v-model="stationid" clearable filterable placeholder="Select Station" size="small" style="width:100%;">
										<el-option v-for="item7 in spbu.list" :key="item7.StationId" :label="item7.StationName" :value="item7.StationId">
										</el-option>
									</el-select>
								</el-form-item>
							</div>
							<div class="col-md-5">	
								<el-form-item label="Date Range:">
									<div class="block">								
										<el-date-picker
										v-model="dateRange"
										type="daterange"
										align="right"
										size="small" 
										unlink-panels
										range-separator="-"
										start-placeholder="Start date"
										end-placeholder="End date"
										format="yyyy-MM-dd"
										value-format="yyyy-MM-dd"
										:picker-options="pickerOptions">
										</el-date-picker>
									</div>
								</el-form-item>
							</div>
							<div class="col-md-2">	
								<el-form-item label=" ">
									<el-button type="primary" size="medium" :loading="loading.table" @click="applyFilter" style="width:100%;">Submit</el-button>
								</el-form-item>
							</div>
						</div>
						<div class="row"></div>
					</el-form>
				</div>
				<div class="mt-0">
					<TodaySummaryTable :items="reportdata.data" :loading="loading.table" :issuccess="loading.isSuccess"  :stationlist="spbu.list"/>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Finance from '@/components/page/Finance.js'
import PieChart from '@/components/chart/Pie.js'
import { Rainbow, Rainbow3, Config, AxiosWithJar, Penanggalan } from '@/utility.js'
//import ReportResultTable from '@/views/pages/ReportResultTable2.vue'
//import Loader from '@/components/loader/Loader2.vue'

import TodaySummaryTable from '@/views/pages/Finance/CashDeposit/Report/TodaySummaryTable.vue'

export default {
	extends: Finance,
	components: { 
        //ReportResultTable,
        TodaySummaryTable
	},
	data(){
		return {
            urlRequestParams: '',
            reportdata: { data: [] },  // Ensure it's an object with a 'data' property
            stationid: '',
            plant: '',
            spbu: {
                list: [],
            },
			options: {},
            loading: {
                table: false,
                isSuccess: false,
            },
            date: { 
				Start: this.$route.query.dateStart ? this.$route.query.dateStart : Penanggalan().tahunSekarang,
				End: this.$route.query.dateEnd ? this.$route.query.dateEnd : Penanggalan().kemarin, 
			},
            dateRange: [this.$route.query.dateStart ? this.$route.query.dateStart : Penanggalan().tahunSekarang, this.$route.query.dateEnd ? this.$route.query.dateEnd : Penanggalan().kemarin], 
            pickerOptions: {
				shortcuts: [{
					text: 'Last week',
					onClick(picker) {
					const end = new Date();
					const start = new Date();
					start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
					picker.$emit('pick', [start, end]);
					}
				}, {
					text: 'Last month',
					onClick(picker) {
					const end = new Date();
					const start = new Date();
					start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
					picker.$emit('pick', [start, end]);
					}
				}, {
					text: 'Last 3 months',
					onClick(picker) {
					const end = new Date();
					const start = new Date();
					start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
					picker.$emit('pick', [start, end]);
					}
				}]
			},
        }
    },
    mounted() {
        this.$emit('childrenRoute');
        this.loadStationList();
        this.getData();
    },
    methods: { 
        async loadStationList(type='') {
			this.urlRequestParams = Config().apiURL
            this.urlRequestParams += "/fuel2/station?"  + (type ? "&type=" + type : "") + (this.plant ? "&plant=" + this.plant : "") + (this.stationid ? "&station=" + this.stationid : "");
			await AxiosWithJar().get(this.urlRequestParams).then(result=>{
				if(result.data.data.length){
					this.spbu.list = result.data.data;
				}
			})
		},
        getData() {
            this.urlRequestParams=Config().apiURL
			this.urlRequestParams+='/v1/cashdeposit/todaysummary?'
            this.urlRequestParams+='&date-range-start='+ (this.dateRange ? this.dateRange[0] : 'undefined')
			this.urlRequestParams+='&date-range-end='+ (this.dateRange ? this.dateRange[1] : 'undefined')
            this.urlRequestParams+='&stationid='+this.stationid

			this.loading.table = true;
			this.loading.isSuccess = false;
			AxiosWithJar().get(this.urlRequestParams)
				.then((response)=>{ 
					this.loading.isSuccess = true;
					this.reportdata.data = response.data.data;  // Update the data property of reportdata
				})
				.catch(error => {
					console.log(error)
				})
				.finally(() => {
					this.loading.table = false;
				})
        },
        applyFilter() {
            this.getData()
        },
    }
}
</script>
